/*
    The OP launch list (MPN-2229), served by the platform server from the frozen OP warehouse
    under api/v1/legacy_dashboard/launch-list/. Every field may be null: the warehouse is a
    copy of whatever the old platform held.
*/

export interface LaunchListRow {
    id: number;
    name?: string | null;
    affiliate_id?: number | null;
    affiliate_name?: string | null;
    start_date?: string | null;
    end_date?: string | null;
    is_active?: boolean | null;
    in_definition?: boolean | null;
    has_control_group?: boolean | null;
    launch_attributes?: string[] | null;
    engagement_manager?: string | null;
    ops_manager?: string | null;
    sales_lead?: string | null;
    created_by?: string | null;
    datetime_modified?: string | null;
}

export interface LaunchListResponse {
    count: number;
    results: LaunchListRow[];
}

export interface NamedOption {
    id: number;
    name: string;
}

export interface LaunchListFilterOptions {
    affiliates?: NamedOption[] | null;
    engagement_managers?: NamedOption[] | null;
    ops_managers?: NamedOption[] | null;
    /** Every launch attribute name and every launch creator in scope, for "More filters". */
    launch_attributes?: string[] | null;
    creators?: NamedOption[] | null;
}

/** The list query, one key per server parameter. Empty string means "all" on the server. */
export interface LaunchListQuery {
    status: string;
    affiliate: string[];
    in_definition: string;
    has_control_group: string;
    starts_before: string;
    ends_before: string;
    starts_after: string;
    ends_after: string;
    engagement_manager: string;
    ops_manager: string;
    /** Attribute names; `attribute_match` says whether a launch needs all of them or any one. */
    attribute: string[];
    attribute_match: "any" | "all";
    /** Creator user ids. */
    created_by: string[];
    modified_after: string;
    search: string;
    sort: string;
    page: number;
    page_size: number;
}

/** The query keys the URL and the request carry as comma-separated lists. */
export const LIST_QUERY_KEYS = ["affiliate", "attribute", "created_by"] as const;

/**
 * The list opens on every launch (MPN-2313). OP's link opened on `?status=1`, Enabled, but
 * statuses were not kept up on the old platform, so Enabled is not the set anyone wants.
 */
export const DEFAULT_LAUNCH_LIST_QUERY: LaunchListQuery = {
    status: "",
    affiliate: [],
    in_definition: "",
    has_control_group: "",
    starts_before: "",
    ends_before: "",
    starts_after: "",
    ends_after: "",
    engagement_manager: "",
    ops_manager: "",
    attribute: [],
    attribute_match: "any",
    created_by: [],
    modified_after: "",
    search: "",
    sort: "-id",
    page: 1,
    page_size: 50,
};

/** The columns the server sorts on, by their sort key. */
export const LAUNCH_SORT_KEYS = [
    "id", "name", "affiliate", "start_date", "end_date", "status", "in_definition", "datetime_modified",
] as const;
